export default {
      id: "icon--twitter-usage",
      viewBox: "0 0 20 16.25",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--twitter-usage",
      toString: function () {
        return this.url;
      }
    }